import ThrottledScreen from 'features/advance/screens/lightning/Throttled/Throttled';
import React from 'react';

export default function ThrottledPage() {
  return <ThrottledScreen />;
}
